import { Identity } from '@integration-frontends/common/auth/core/model';

export const IDENTITY_STORE_TOKEN = 'IDENTITY_STORE_TOKEN';
export interface IIdentityStore {
  get: () => Promise<Identity>;
  set: (identity: Identity) => Promise<void>;
}
